module.exports = __webpack_public_path__ + "static/media/twa_sat_cropped.b9ac20ed.webp";